import { render, staticRenderFns } from "./CompleteTestDialog.vue?vue&type=template&id=6c74ff87&"
import script from "./CompleteTestDialog.vue?vue&type=script&lang=ts&"
export * from "./CompleteTestDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports